import type { ReactNode } from "react";
import { pageEstimateTooltip } from "@/utils/documentSize";

interface PageEstimateHintProps {
  characters: number;
  children: ReactNode;
  className?: string;
}

/** Dotted underline + tooltip for approximate page counts. */
export function PageEstimateHint({ characters, children, className }: PageEstimateHintProps) {
  return (
    <abbr
      title={pageEstimateTooltip(characters)}
      className={`cursor-help border-b border-dotted border-current no-underline ${className ?? ""}`}
    >
      {children}
    </abbr>
  );
}
